import React, { useEffect, useState } from 'react'
import { archiveJobCategory, getJobCategoryList } from '../../../actions/utilitiesAction'
import List from '../../../component/Utilities/JobCategory/JobCategoryList'
import constant from '../../../constant'
import queryString from 'query-string'
import { useLocation } from "react-router-dom";

const JobCategoryList = () => {

    const [list, setList] = useState(null)
    const [count, setCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [keyword, setKeyword] = useState('')
    const [showLoader, setShowLoader] = useState(false)
    const location = useLocation()

    useEffect(() => {
        const qParams = queryString.parse(location.search)
        getJobCategoryLists(qParams?.p ? qParams?.p : qParams?.pageno ? qParams.pageno : currentPage)
        document.title = constant.title.JobCategoryList
    }, [currentPage])

    const getJobCategoryLists = (page) => {
        setShowLoader(true)
        getJobCategoryList({ KEYWORD: keyword, pageNumber: page }).then((res) => {
            if (res.status) {
                setShowLoader(false)
                setList(res.result.list)
                setCount(res.result.count)
            }
        }).catch((err) => {
            alert(err)
        })
    }


    const updateStatus = (model) => {
        archiveJobCategory(model).then((res) => {
            if (res.status) {
                getJobCategoryLists(currentPage)
            } else {
                alert(res.error)
            }
        }).catch((err) => {
            alert(err)
        })
    }

    return (
        <React.Fragment>
            <List
                list={list}
                updateStatus={updateStatus}
                getJobCategoryLists={(page => getJobCategoryLists(page))}
                count={count}
                setPage={setCurrentPage}
                keyword={setKeyword}
                showLoader={showLoader}
                cpage={currentPage}
            />
        </React.Fragment>
    )
}
export default JobCategoryList;